import {Modal} from "antd";
import React from "react";
import {injectIntl} from "react-intl";
import Candidates from "../SeasonOfficials/Candidates/Candidates";
import {useSportConfiguration} from "~hooks/useSportConfiguration";

const AddPersonToStaffModal = ({ intl: { formatMessage }, isOpen, setIsOpen, pageRef, reloadData, ...props }) => {
  const {seasonStaffRoles} = useSportConfiguration();

  return (
    <Modal
      open={isOpen}
      okButtonProps={{ style: { display: "none" } }}
      onCancel={() => setIsOpen(false)}
      width={800}
      title={formatMessage({
        id: "staff.add",
        defaultMessage: "Add New Staff Member",
      })}
      cancelText={formatMessage({
        id: "cancel",
        defaultMessage: "Cancel",
      })}
    >
      <Candidates {...props} refetch={reloadData} pageRef={pageRef} roles={seasonStaffRoles} />
    </Modal>
  );
};

export default injectIntl(AddPersonToStaffModal);
